import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import axios from 'axios';

Vue.use(Vuex)

export default new Vuex.Store({
  //TODO make sure strict is set to false for uat/production (https://vuex.vuejs.org/guide/strict.html#development-vs-production)
  strict: true,
  modules,
  state: {
    settings: {}
  },
  actions: {
    getSettings({commit}) {
      axios.get('/Settings')
      .then((response) => {
          commit("setSettings", response.data)
        }, (error) => {
          console.log(error);
        });
    }
  },
  mutations: {
    setSettings(state, payload) {
        state.settings = payload;
    }
  },
  getters: {
    getDeclarationExpiryInDays: state => state.settings.ExpiresInDays,
    getTenDigitHsCodeDestinationCountryCodes: state => state.settings.TenDigitHsCodeDestinationCountryCodes
  }
})
